import { z } from 'zod'

// Identity заказчика — второй контур сессии (00-architecture § 3): issuer
// company-backend (api.hub.stit.tech), cookie stit_customer, claims несут
// company_id / account_role / products. Источник — /auth/customer/{login,me}
// (huma-обёртка {data: CustomerProfileView}). Email в модели аккаунта нет —
// нет его и здесь.

export const CustomerProfileViewSchema = z.object({
  account_id: z.string(),
  company_id: z.string(),
  full_name: z.string(),
  job_title: z.string().optional(),
  role: z.string(),
  // Go отдаёт пустой слайс как null — набор продуктов приходит nullable.
  products: z.array(z.string()).nullable(),
})

export type CustomerProfileView = z.infer<typeof CustomerProfileViewSchema>

export const CustomerProfileResponseSchema = z.object({ data: CustomerProfileViewSchema })

export interface CustomerProfile {
  accountId: string
  companyId: string
  fullName: string
  jobTitle: string
  role: string
  // admin — админ СВОЕЙ компании (гейт «Команды» в ЛК продукта), к правам в
  // экосистеме отношения не имеет (00-architecture § 2).
  isCompanyAdmin: boolean
  products: string[]
}

export function customerProfileFrom(view: CustomerProfileView): CustomerProfile {
  return {
    accountId: view.account_id,
    companyId: view.company_id,
    fullName: view.full_name,
    jobTitle: view.job_title ?? '',
    role: view.role,
    isCompanyAdmin: view.role === 'admin',
    products: view.products ?? [],
  }
}
